"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApiStateDispatched = exports.createApiState = exports.emptyApiState = void 0;
exports.emptyApiState = {
    data: null,
    error: null,
    loading: false,
    success: false
};
const createApiState = (state) => {
    return { ...exports.emptyApiState, ...state };
};
exports.createApiState = createApiState;
const isApiStateDispatched = (apiState) => !!apiState.data || apiState.loading || apiState.error !== null;
exports.isApiStateDispatched = isApiStateDispatched;
